import { Injectable, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AESEncrypt } from 'src/app/common/Helper/AESEncryp';
import { WebStorageService, LOCAL_STORAGE } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root'
})

export class HomeService {
  aes = new AESEncrypt();
  endpoint = environment.apiUrl + 'Administracion/InformacionGeneral/';
  //endpoint = 'http://localhost:49819/' + 'InformacionGeneral/';

  endpointPLD = environment.apiUrl + 'Administracion/PLD/';
  //endpointPLD = 'http://localhost:53580/PLD/';

  constructor(private http: HttpClient, 
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,) {
  }

  //#region "InformacionGeneral"
  estatusClientes(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'estatusClientes'
    );
  }

  obtieneSucursales(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'obtieneSucursales'
    );
  }

  obtieneEstatusCreditosPolizas(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'estatusCreditosPolizas'
    );
  }

  obtieneEstatusCuentas(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'estatusCuentas'
    );
  }

  obtieneProductos(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'obtieneProductos'
    );
  }

  obtieneEntidad(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'obtieneEntidades'
    );
  }

  obtieneTipoCambioCincoAtras(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'tipoCambioCincoDiasAtras'
    );
  }

  obtieneSujetoObligado(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'sujetoObligado'
    );
  }
  //#endregion "InformacionGeneral"

  //#region "PLD"
  contadorAlertas(): Observable<any> {
    return this.http.get<any>(
      this.endpointPLD + 'contadorAlertas'
    );
  }

  alertasActivas(): Observable<any> {
    return this.http.get<any>(
      this.endpointPLD + 'alertasActivas'
    );
  }

  riesgoClientes(): Observable<any> {
    return this.http.get<any>(
      this.endpointPLD + 'riesgoClientes'
    );
  }

  contadorTransacciones(): Observable<any> {
    return this.http.get<any>(
      this.endpointPLD + 'contadorTransacciones'
    );
  }

  ultimaActualizacionRiesgo(): Observable<any> {
    return this.http.get<any>(
      this.endpointPLD + 'ultimaActualizacionRiesgo'
    );
  }

  razonSocial(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'fichaTecnica'
    )
  }
  //#endregion "PLD"
  buscarAplicacion(): Observable<any> {
		let resultado = this.http.get(`${this.endpoint}getAppData`);
		return resultado;
	}

  uploadLicense(formData: FormData) {
    return this.http.post<any>(
      `${this.endpoint}UploadLicense`,
      formData
    );
  }

	getEnvironment() : any | null {
    try{
      const encrypted = this.storage.get('environment');

      if(!encrypted){
        return null;
      }

      return this.aes.decryptModel(encrypted);
    }catch(error){
      return null;
    }
	}

  removeEnvironment(){
    this.storage.remove('environment');
  }
}

